import { createSlice } from '@reduxjs/toolkit'
export const mapDataSlice = createSlice({
  name: 'mapRefresh',
  initialState: {
    values: []
  },
  reducers: {
    addMapData: (state, action) => {
      state.values = action.payload;
      return state;
    },
  }
})
export const { addMapData } = mapDataSlice.actions;
export default mapDataSlice.reducer; 
